/* ADHchi — Dopamine Button, PDP interactions & Micro-interactions */

document.addEventListener('DOMContentLoaded', function() {
  const dopamineBtn = document.querySelector('.dopamine-btn');
  const stickyCta = document.getElementById('sticky-cta');
  const buyBox = document.getElementById('buy-box');

  // ============================================
  // Dopamine Button — confetti on click
  // ============================================
  if (dopamineBtn) {
    const emojis = ['✨', '🧠', '⚡', '🔥', '💜', '🌀', '🎯', '☯️', '🧘', '💫'];
    const colors = ['#FF6B35', '#2563EB', '#A3E635', '#EC4899', '#A78BFA', '#FFD23F'];

    // Speech bubble tooltip
    const bubble = document.createElement('div');
    bubble.className = 'dopamine-bubble';
    bubble.innerHTML = 'pssst... need dopamine? press me';
    document.body.appendChild(bubble);

    // Show bubble after 10 seconds (only if sticky CTA isn't visible)
    setTimeout(() => {
      if (!stickyCta || !stickyCta.classList.contains('pdp-sticky-cta--visible')) {
        bubble.classList.add('dopamine-bubble--visible');
        setTimeout(() => bubble.classList.remove('dopamine-bubble--visible'), 5000);
      }
    }, 10000);

    // Confetti pop sound using Web Audio API
    function playConfettiSound() {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const pop = ctx.createOscillator();
        const popGain = ctx.createGain();
        pop.type = 'sine';
        pop.frequency.setValueAtTime(800, ctx.currentTime);
        pop.frequency.exponentialRampToValueAtTime(1600, ctx.currentTime + 0.05);
        pop.frequency.exponentialRampToValueAtTime(200, ctx.currentTime + 0.15);
        popGain.gain.setValueAtTime(0.3, ctx.currentTime);
        popGain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.2);
        pop.connect(popGain).connect(ctx.destination);
        pop.start(ctx.currentTime);
        pop.stop(ctx.currentTime + 0.2);
        [1200, 1500, 1800].forEach((freq, i) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'sine';
          osc.frequency.value = freq;
          gain.gain.setValueAtTime(0.08, ctx.currentTime + 0.05 + i * 0.06);
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15 + i * 0.06);
          osc.connect(gain).connect(ctx.destination);
          osc.start(ctx.currentTime + 0.05 + i * 0.06);
          osc.stop(ctx.currentTime + 0.2 + i * 0.06);
        });
      } catch(e) {}
    }

    dopamineBtn.addEventListener('click', function(e) {
      bubble.classList.remove('dopamine-bubble--visible');
      playConfettiSound();
      for (let i = 0; i < 20; i++) {
        setTimeout(() => createConfetti(e.clientX, e.clientY, colors, emojis), i * 30);
      }
      dopamineBtn.style.transform = 'scale(0.85)';
      setTimeout(() => { dopamineBtn.style.transform = 'scale(1.15)'; }, 100);
      setTimeout(() => { dopamineBtn.style.transform = 'scale(1)'; }, 250);
    });
  }

  function createConfetti(x, y, colors, emojis) {
    const piece = document.createElement('div');
    piece.className = 'confetti-piece';
    if (Math.random() > 0.5) {
      piece.textContent = emojis[Math.floor(Math.random() * emojis.length)];
      piece.style.fontSize = (Math.random() * 16 + 12) + 'px';
    } else {
      piece.style.width = (Math.random() * 10 + 6) + 'px';
      piece.style.height = (Math.random() * 10 + 6) + 'px';
      piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
    }
    const angle = Math.random() * Math.PI * 2;
    const velocity = Math.random() * 150 + 50;
    const startX = x + Math.cos(angle) * 20;
    const startY = y + Math.sin(angle) * 20;
    piece.style.left = startX + 'px';
    piece.style.top = startY + 'px';
    const endX = startX + Math.cos(angle) * velocity;
    const endY = startY - Math.random() * 200 - 100;
    piece.animate([
      { transform: 'translateY(0) rotate(0deg) scale(1)', opacity: 1 },
      { transform: `translate(${endX - startX}px, ${endY - startY}px) rotate(${Math.random() * 720 - 360}deg) scale(0)`, opacity: 0 }
    ], { duration: Math.random() * 800 + 600, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' });
    document.body.appendChild(piece);
    setTimeout(() => piece.remove(), 1500);
  }

  // ============================================
  // Sticky CTA — appears after scrolling past buy box, hides dopamine button
  // ============================================
  if (stickyCta && buyBox) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // Scrolled past buy box — show sticky CTA, hide dopamine button
          stickyCta.classList.add('pdp-sticky-cta--visible');
          if (dopamineBtn) dopamineBtn.style.display = 'none';
          const bubble = document.querySelector('.dopamine-bubble');
          if (bubble) bubble.classList.remove('dopamine-bubble--visible');
        } else {
          // Buy box visible — hide sticky CTA, show dopamine button
          stickyCta.classList.remove('pdp-sticky-cta--visible');
          if (dopamineBtn) dopamineBtn.style.display = 'flex';
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(buyBox);

    // Smooth scroll to the buying area (bundle builder or ATC button)
    stickyCta.querySelector('.pdp-sticky-cta__btn')?.addEventListener('click', function(e) {
      e.preventDefault();
      var scrollTarget = document.getElementById('pdp-bundle')
        || document.getElementById('pdp-atc-btn')
        || buyBox;
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // ============================================
  // Product Gallery — thumbnail switching
  // ============================================
  const mainImage = document.getElementById('pdp-main-image');
  const thumbs = document.querySelectorAll('.pdp-gallery__thumb');

  if (mainImage && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        thumbs.forEach(t => t.classList.remove('pdp-gallery__thumb--active'));
        this.classList.add('pdp-gallery__thumb--active');
        mainImage.src = this.dataset.src;
        mainImage.style.opacity = '0';
        setTimeout(() => { mainImage.style.opacity = '1'; }, 50);
      });
    });
    mainImage.style.transition = 'opacity 0.3s ease';
  }

  // ============================================
  // Variant option buttons
  // ============================================
  document.querySelectorAll('.pdp-option__btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const parent = this.closest('.pdp-option__values');
      parent.querySelectorAll('.pdp-option__btn').forEach(b => b.classList.remove('pdp-option__btn--active'));
      this.classList.add('pdp-option__btn--active');
    });
  });

  // ============================================
  // Bundle Builder — tier selection
  // ============================================
  const bundleContainer = document.getElementById('pdp-bundle');
  const atcBtn = document.getElementById('pdp-atc-btn');

  if (bundleContainer && atcBtn) {
    const tiers = bundleContainer.querySelectorAll('.pdp-bundle__tier');
    const form = atcBtn.closest('form');
    const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

    // Add hidden quantity input if not exists
    if (form && !qtyInput) {
      const hiddenQty = document.createElement('input');
      hiddenQty.type = 'hidden';
      hiddenQty.name = 'quantity';
      hiddenQty.value = '1';
      hiddenQty.id = 'bundle-qty';
      form.appendChild(hiddenQty);
    }

    tiers.forEach(function(tier) {
      tier.addEventListener('click', function() {
        // Remove active from all
        tiers.forEach(function(t) { t.classList.remove('pdp-bundle__tier--active'); });
        // Add active to clicked
        this.classList.add('pdp-bundle__tier--active');
        // Check radio
        var radio = this.querySelector('.pdp-bundle__radio');
        if (radio) radio.checked = true;

        // Update quantity
        var qty = parseInt(this.dataset.qty) || 1;
        var bundleQtyInput = document.getElementById('bundle-qty') || form.querySelector('input[name="quantity"]');
        if (bundleQtyInput) bundleQtyInput.value = qty;

        // Update ATC button text
        var priceEl = this.querySelector('.pdp-bundle__tier-price');
        var price = priceEl ? priceEl.textContent.trim() : '';
        var discount = parseInt(this.dataset.discount) || 0;

        if (qty === 1) {
          atcBtn.innerHTML = 'Feed the Dopamine — ' + price;
        } else {
          var total = price.replace(/[^0-9.]/g, '');
          var totalPrice = (parseFloat(total) * qty).toFixed(2);
          atcBtn.innerHTML = 'Feed the Dopamine — ' + qty + ' × ' + price + ' = £' + totalPrice;
        }
      });
    });
  }

  // ============================================
  // AJAX Add to Cart — stay on page, open cart drawer
  // ============================================
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    // Skip upsell forms inside cart drawer
    if (form.closest('.cart-drawer')) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.innerHTML = 'Adding...';
        submitBtn.disabled = true;
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        // Refresh the cart drawer content
        return fetch('/?sections=cart-drawer');
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && data['cart-drawer']) {
          var temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          var newPanel = temp.querySelector('.cart-drawer__panel');
          var oldPanel = drawer.querySelector('.cart-drawer__panel');
          if (newPanel && oldPanel) {
            oldPanel.innerHTML = newPanel.innerHTML;
          }
        }

        // Update header cart count
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('.cart-drawer__count, .adhchi-header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
        });

        // Load upsell products
        if (window._adhchiLoadUpsells) window._adhchiLoadUpsells();

        // Open the cart drawer
        if (drawer) {
          drawer.classList.add('cart-drawer--open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';

          // Re-attach cart drawer event listeners
          var closeBtn = drawer.querySelector('#cart-drawer-close');
          var overlay = drawer.querySelector('#cart-drawer-overlay');
          function closeDrawer() {
            drawer.classList.remove('cart-drawer--open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
          if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
          if (overlay) overlay.addEventListener('click', closeDrawer);

          // Re-attach qty and remove buttons
          drawer.querySelectorAll('.cart-drawer__qty-btn').forEach(function(btn) {
            btn.addEventListener('click', function() {
              var key = this.dataset.key;
              var action = this.dataset.action;
              var item = this.closest('.cart-drawer__item');
              var qtySpan = item.querySelector('.cart-drawer__item-qty span');
              var currentQty = parseInt(qtySpan.textContent);
              var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: Math.max(newQty, 0) })
              }).then(function() {
                return fetch('/?sections=cart-drawer');
              }).then(function(r) { return r.json(); }).then(function(sData) {
                if (sData['cart-drawer']) {
                  var t = document.createElement('div');
                  t.innerHTML = sData['cart-drawer'];
                  var np = t.querySelector('.cart-drawer__panel');
                  var op = drawer.querySelector('.cart-drawer__panel');
                  if (np && op) op.innerHTML = np.innerHTML;
                }
                fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
                  document.querySelectorAll('.cart-drawer__count, .adhchi-header__cart-count').forEach(function(el) {
                    el.textContent = c.item_count;
                  });
                });
              });
            });
          });

          drawer.querySelectorAll('.cart-drawer__remove-btn').forEach(function(btn) {
            btn.addEventListener('click', function() {
              var key = this.dataset.key;
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              }).then(function() {
                return fetch('/?sections=cart-drawer');
              }).then(function(r) { return r.json(); }).then(function(sData) {
                if (sData['cart-drawer']) {
                  var t = document.createElement('div');
                  t.innerHTML = sData['cart-drawer'];
                  var np = t.querySelector('.cart-drawer__panel');
                  var op = drawer.querySelector('.cart-drawer__panel');
                  if (np && op) op.innerHTML = np.innerHTML;
                }
                fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
                  document.querySelectorAll('.cart-drawer__count, .adhchi-header__cart-count').forEach(function(el) {
                    el.textContent = c.item_count;
                  });
                });
              });
            });
          });

          // Animate shipping bar
          var fill = drawer.querySelector('.cart-drawer__shipping-fill');
          if (fill) {
            var targetWidth = fill.style.width;
            fill.style.width = '0%';
            fill.style.transition = 'width 1s cubic-bezier(0.4, 0, 0.2, 1)';
            setTimeout(function() { fill.style.width = targetWidth; }, 100);
          }
        }
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
      })
      .finally(function() {
        if (submitBtn) {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }
      });
    });
  });

  // ============================================
  // UGC Video Lightbox
  // ============================================
  const lightbox = document.getElementById('pdp-lightbox');

  if (lightbox) {
    const lightboxClose = lightbox.querySelector('.pdp-lightbox__close');
    const lightboxOverlay = lightbox.querySelector('.pdp-lightbox__overlay');

    function openLightbox() {
      lightbox.classList.add('pdp-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('pdp-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Open from mini UGC thumbnails
    document.querySelectorAll('.pdp-ugc-mini__item').forEach(function(item) {
      item.addEventListener('click', openLightbox);
    });

    // Open from carousel cards
    document.querySelectorAll('.pdp-ugc-carousel__card').forEach(function(card) {
      card.addEventListener('click', openLightbox);
    });

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxOverlay) lightboxOverlay.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('pdp-lightbox--open')) {
        closeLightbox();
      }
    });
  }

  // ============================================
  // Email Popup — list builder
  // ============================================
  var emailPopup = document.getElementById('email-popup');

  if (emailPopup) {
    var popupOverlay = emailPopup.querySelector('.email-popup__overlay');
    var popupClose = emailPopup.querySelector('.email-popup__close');
    var popupForm = document.getElementById('email-popup-form');
    var popupSuccess = document.getElementById('email-popup-success');
    var popupEmailInput = document.getElementById('email-popup-email');

    // Check if popup was already dismissed (cookie)
    function getPopupCookie() {
      return document.cookie.split(';').some(function(c) {
        return c.trim().startsWith('adhchi_popup_dismissed=');
      });
    }

    function setPopupCookie() {
      var d = new Date();
      d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days
      document.cookie = 'adhchi_popup_dismissed=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }

    function openPopup() {
      if (getPopupCookie()) return;
      emailPopup.classList.add('email-popup--open');
      emailPopup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      emailPopup.classList.remove('email-popup--open');
      emailPopup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setPopupCookie();
    }

    // Show after 8 seconds
    if (!getPopupCookie()) {
      setTimeout(openPopup, 8000);
    }

    // Exit intent (desktop only)
    if (!getPopupCookie() && window.innerWidth > 768) {
      var exitFired = false;
      document.addEventListener('mouseout', function(e) {
        if (exitFired) return;
        if (e.clientY < 5 && !emailPopup.classList.contains('email-popup--open')) {
          exitFired = true;
          openPopup();
        }
      });
    }

    if (popupClose) popupClose.addEventListener('click', closePopup);
    if (popupOverlay) popupOverlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && emailPopup.classList.contains('email-popup--open')) {
        closePopup();
      }
    });

    // Form submit — Klaviyo subscribe
    if (popupForm) {
      popupForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = popupEmailInput.value.trim();
        if (!email) return;

        var btn = popupForm.querySelector('.email-popup__submit');
        btn.textContent = 'Joining...';
        btn.disabled = true;

        // Klaviyo identify
        if (window._learnq) {
          window._learnq.push(['identify', { '$email': email }]);
        }

        // Klaviyo subscribe API
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=ReWDfJ', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                custom_source: 'ADHchi Popup'
              },
              relationships: {
                list: { data: { type: 'list', id: 'VtqGVF' } }
              }
            }
          })
        }).catch(function() {}).finally(function() {
          popupForm.style.display = 'none';
          popupSuccess.style.display = '';
          setPopupCookie();
        });
      });
    }
  }

  // ============================================
  // Waitlist Modal — Coming Soon products
  // ============================================
  const waitlistModal = document.getElementById('waitlist-modal');

  if (waitlistModal) {
    const waitlistOverlay = waitlistModal.querySelector('.waitlist-modal__overlay');
    const waitlistClose = waitlistModal.querySelector('.waitlist-modal__close');
    const waitlistForm = document.getElementById('waitlist-form');
    const waitlistSuccess = document.getElementById('waitlist-success');
    const waitlistProductName = document.getElementById('waitlist-product-name');
    const waitlistEmail = document.getElementById('waitlist-email');

    function openWaitlist(productTitle) {
      if (waitlistProductName) waitlistProductName.textContent = productTitle;
      waitlistModal.classList.add('waitlist-modal--open');
      waitlistModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Reset form state
      if (waitlistForm) waitlistForm.style.display = '';
      if (waitlistSuccess) waitlistSuccess.style.display = 'none';
      if (waitlistEmail) waitlistEmail.value = '';
    }

    function closeWaitlist() {
      waitlistModal.classList.remove('waitlist-modal--open');
      waitlistModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Trigger from Coming Soon cards
    document.querySelectorAll('[data-waitlist-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openWaitlist(this.dataset.productTitle || 'this one');
      });
    });

    if (waitlistClose) waitlistClose.addEventListener('click', closeWaitlist);
    if (waitlistOverlay) waitlistOverlay.addEventListener('click', closeWaitlist);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && waitlistModal.classList.contains('waitlist-modal--open')) {
        closeWaitlist();
      }
    });

    // Form submission — subscribe via Klaviyo client API
    if (waitlistForm) {
      waitlistForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = waitlistEmail.value.trim();
        if (!email) return;

        var submitBtn = waitlistForm.querySelector('.waitlist-modal__submit');
        submitBtn.textContent = 'Joining...';
        submitBtn.disabled = true;

        // Klaviyo client-side subscribe (uses on-site tracking)
        var klaviyoListId = 'Yavn8L';
        var productName = waitlistProductName ? waitlistProductName.textContent : '';

        // Use Klaviyo's client API if available
        if (window._learnq) {
          window._learnq.push(['identify', {
            '$email': email,
            'Drop Interest': productName
          }]);
        }

        // Also POST to Klaviyo's subscribe endpoint — Drop List
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=ReWDfJ', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: { 'Drop Interest': productName }
                    }
                  }
                },
                custom_source: 'ADHchi Drop Interest'
              },
              relationships: {
                list: { data: { type: 'list', id: klaviyoListId } }
              }
            }
          })
        }).catch(function() {
          // Silent fail — Klaviyo identify above is the backup
        }).finally(function() {
          // Show success regardless (email captured via identify at minimum)
          waitlistForm.style.display = 'none';
          waitlistSuccess.style.display = '';
        });
      });
    }
  }

  // UGC Carousel — auto-scroll handled by CSS animation

  // ============================================
  // Scroll reveal animations
  // ============================================
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-animate--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 100px 0px' });

    document.querySelectorAll('.section-animate').forEach(el => {
      // Immediately show elements already in viewport on load
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 100) {
        el.classList.add('section-animate--visible');
      } else {
        observer.observe(el);
      }
    });
  } else {
    document.querySelectorAll('.section-animate').forEach(el => {
      el.classList.add('section-animate--visible');
    });
  }

  // ============================================
  // Product card stagger reveal
  // ============================================
  if ('IntersectionObserver' in window) {
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('card-visible');
          cardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card').forEach(card => {
      cardObserver.observe(card);
    });
  } else {
    document.querySelectorAll('.product-card').forEach(card => {
      card.classList.add('card-visible');
    });
  }
});
